export const clientPreferences = {
  get prefersReducedMotion() {
    return window.matchMedia("(prefers-reduced-motion: reduce)")?.matches ?? false;
  },
};
